import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, callGameServerApi } from '../Helpers';
import { BsPeople, BsChatDots } from 'react-icons/bs';
import OneChatRoom from '../ones/OneChatRoom';


export default function View(props) {
  const appContext = useContext(AppContext);

  const [ chatRooms, setChatRooms ] = useState(null);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);


  const init = async () => {
    setReady(false);
    await getUserChatRooms();
    setReady(true);
  }

  async function getUserChatRooms() {
    setLoading(true);
    await callGameServerApi("get-user-chatrooms", {}).then(response => {
      if(response.status === 1) {
        setChatRooms(response.chatRooms);
      } else {
        appContext.tellError(response.msg);
      }
    })
    setLoading(false);
  }

  
  useEffect(() => {
    init();
  }, []);


  if(ready && !loading) {
    return (
      <div className='container' style={{ padding: "0px" }}>
        <div
          className='card'
          style={{ marginTop: "30px" }}
        >
          <div 
            className='card-body d-flex'>
            <BsPeople
              size={60}
              style={{
                flexShrink: "0",
                marginRight: "20px"
              }}
            />
            <div className='' style={{ flexGrow: "1" }}>
              <h6>Community Chat</h6>
              <span className='text-muted' style={{ fontSize: "12px" }}>
                All Soldrax users can send and read messages in this chat
              </span>

              <div className='text-end' style={{ marginTop: "20px" }}>
                <button onClick={() => appContext.navTo({ item: 'view', subItem:'chat' })} className='btn btn-rounded bg-bluish' style={{ width: "150px", marginRight:"0px" }}>
                  <BsChatDots className='align-self-center' size={30}/><br/>
                  <small className='font-regular align-self-center'>
                    Chat Now!
                  </small>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12' style={{ marginBottom: "20px", marginTop: "30px" }}>
            <h5 className='text-goldish'>Your Chats</h5>
            <h6 className='text-muted font-light'>Personal Chats</h6>
          </div>

          <div className='col-md-12'>
            {
              (chatRooms && chatRooms.length > 0) ?
              chatRooms.map((item, i) => {
                return <OneChatRoom key={i} chatData={item}/>
              })
              :
              <small className='font-light'>No Chats were found</small>
            }
          </div>
        </div>

      </div>
    )
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    )
  }
}
